import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { BenefitsListPage, BenefitsListPageType } from '../@types/benefitsListPage';
import { KAEUFER_PLUS_PATH, MIETER_PLUS_PATH, WOHNEN_PLUS_PATH } from '../domain/routes';

type PlusPathsMap = {
  [key: string]: BenefitsListPage.MieterPlus | BenefitsListPage.WohnenPlus | BenefitsListPage.KauferPlus;
};

const PLUS_PATHS: PlusPathsMap = {
  [MIETER_PLUS_PATH]: BenefitsListPage.MieterPlus,
  [WOHNEN_PLUS_PATH]: BenefitsListPage.WohnenPlus,
  [KAEUFER_PLUS_PATH]: BenefitsListPage.KauferPlus,
};
const BENEFITS_PAGES = [
  BenefitsListPageType.MieterPlus,
  BenefitsListPageType.WohnenPlus,
  BenefitsListPageType.KauferPlus,
] as const;

export const useGetBenefitsListPage = () => {
  const { pathname } = useLocation();
  const plusPath = Object.keys(PLUS_PATHS).find((path) => pathname.includes(path)) || MIETER_PLUS_PATH;
  return PLUS_PATHS[plusPath];
};

export const useGetBenefitPageName = (): BenefitsListPageType => {
  const { pathname } = useLocation();
  const pageName = useMemo(
    () => BENEFITS_PAGES.find((path) => path === pathname.replace('/', '')) || BenefitsListPageType.MieterPlus,
    [pathname],
  );

  return pageName;
};
